var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"order-list"},_vm._l((_vm.documents),function(document){return _c('DocumentLink',{attrs:{"item":document._attributes ? document._attributes : document},on:{"document-deleted":_vm.documentDeleted}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }